import BaseRequest from './BaseRequest';

const schema = 'transaction';

export default class TransactionRequest extends BaseRequest {
  /** *
   *
   * @param {Object} params
   * @param {number} params.pos
   * @param {number} params.count
   * @param {number} params.trans_type
   * @param {number} params.trans_status
   * @param {string} params.currency
   * @param {string} params.contract
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchTransactionHistory(params) {
    const url = `${schema}/history`;
    return this.get(url, params);
  }

  fetchTransactionFilterHistory(params) {
    const url = `${schema}/history-filter`;
    return this.get(url, params);
  }

  /** *
   *
   * @param {Object} params
   * @param {number} params.pos
   * @param {number} params.count
   * @param {string} params.address
   * @param {string} params.contract
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchHistoryByAddress(params) {
    const url = `${schema}/history/address`;
    return this.get(url, params);
  }

  /** *
   *
   * @param {Object} params
   * @param {number} params.pos
   * @param {number} params.count
   * @param {number} params.trans_type
   * @param {number} params.trans_status
   * @param {string} params.currency
   * @param {string} params.contract
   * @param {string} params.pubkey
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchUserTransactionHistory(params) {
    const url = `${schema}/user-history`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.password
   * @param {string} params.email
   * @param {string} params.country
   * @param {string} params.home_address
   * @param {string} params.postal_code
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  withdrawal(params) {
    const url = `${schema}/withdrawal`;
    return this.post(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.pos
   * @param {string} params.count
   * @param {number} params.trans_type
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchWithdrawalHistory(params) {
    const url = `${schema}/history`;
    return this.get(url, params);
  }

  /**
   * @param {Object} params
   * @param {string} params.currency
   * @param {string} params.contract
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchLimit24h(params) {
    const url = `${schema}/limit-24h`;
    return this.get(url, params);
  }

  /**
   * @param {string} coin
   * @param {int} params.pos
   * @param {int} params.count
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchTransactionErrors(params) {
    const url = `${schema}/tx-error`;
    return this.get(url, params);
  }

  /**
   * @param {string} coin
   * @param {int} params.pos
   * @param {int} params.count
   * @param {int} params.start
   * @param {int} params.end
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchTransactionErrorsFilter(params) {
    const url = `${schema}/tx-error-filter`;
    return this.get(url, params);
  }

  /**
   * @param {string} coin
   * @param {int} params.pos
   * @param {int} params.count
   * @param {int} params.start
   * @param {int} params.end
   * @param {int} params.txHash
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  searchTransactionErrors(params) {
    const url = `${schema}/search-tx-error`;
    return this.get(url, params);
  }

  searchTransById(params) {
    const url = `${schema}/single`;
    return this.get(url, params);
  }

  verifyTransaction(data) {
    const url = `${schema}/verify`;
    return this.post(url, data);
  }

  acceptTransaction(data) {
    const url = `${schema}/accept`;
    return this.post(url, data);
  }

  deleteTransaction(params) {
    const url = `${schema}/delete-tx-error`;
    return this.del(url, { params });
  }

  fetchVerifyHistory(params) {
    const url = `${schema}/verify-history`;
    return this.get(url, params);
  }
}
